import { useCallback, useEffect, useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { saCard, fmtD, SABadge, PAYMENT_STATUS } from "../../components/saShared";

const FILTERS = [
  { key: "", label: "Tutti" },
  { key: "pagato", label: "Pagati" },
  { key: "in_attesa", label: "In attesa" },
  { key: "fallito", label: "Falliti" },
  { key: "rimborsato", label: "Rimborsati" },
];

export default function SAPagamenti() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("");

  const load = useCallback(() => {
    api.get(`/superadmin/payments${status ? `?status=${status}` : ""}`).then((r) => setList(r.data)).catch(() => {});
  }, [status]);

  useEffect(() => { load(); }, [load]);

  const resendInvoice = async (pid) => {
    try {
      const r = await api.post(`/superadmin/payments/${pid}/resend-invoice`);
      if (r.data.ok) toast.success(`Ricevuta reinviata a ${r.data.to}`);
      else toast.error(`Invio non riuscito: ${r.data.error || "errore"}`);
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-4" data-testid="sa-pagamenti">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Pagamenti</h1>
        <div className="flex gap-1.5">
          {FILTERS.map((f) => (
            <button key={f.key} onClick={() => setStatus(f.key)} data-testid={`pay-filter-${f.key || "tutti"}`}
              className={`h-8 px-3 rounded-full text-[11px] font-bold border transition ${status === f.key ? "bg-amber-400 text-zinc-950 border-amber-400" : "bg-zinc-900 text-zinc-400 border-zinc-700"}`}>
              {f.label}
            </button>
          ))}
        </div>
      </div>
      <div className={`${saCard} overflow-x-auto`}>
        <table className="w-full text-sm min-w-[820px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
              {["Ristorante", "Importo", "Data", "Stato", "Metodo", "Invoice", "Stripe ID", "Errore", ""].map((h) => (
                <th key={h} className="px-4 py-3 font-semibold">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800/60">
            {list.map((p) => (
              <tr key={p.id} className="hover:bg-zinc-800/40" data-testid={`pay-row-${p.id}`}>
                <td className="px-4 py-3 font-semibold text-zinc-100">{p.restaurant_name}</td>
                <td className="px-4 py-3 text-zinc-200">€{p.amount} {p.currency?.toUpperCase()}</td>
                <td className="px-4 py-3 text-xs text-zinc-400">{fmtD(p.created_at)}</td>
                <td className="px-4 py-3">
                  <SABadge map={PAYMENT_STATUS} value={p.status} />
                  {p.mock && <span className="ml-1.5 text-[9px] font-bold text-zinc-500 border border-zinc-700 rounded-full px-1.5 py-0.5">MOCK</span>}
                </td>
                <td className="px-4 py-3 text-xs text-zinc-400 capitalize">{p.method || "—"}</td>
                <td className="px-4 py-3 text-xs text-zinc-400">{p.invoice || "—"}</td>
                <td className="px-4 py-3 text-xs font-mono text-zinc-500">{p.stripe_payment_intent || p.stripe_invoice_id || "—"}</td>
                <td className="px-4 py-3 text-xs text-rose-400">{p.error || "—"}</td>
                <td className="px-4 py-3">
                  {p.status === "pagato" && (
                    <button onClick={() => resendInvoice(p.id)} data-testid={`pay-resend-${p.id}`}
                      title="Reinvia ricevuta PDF via email"
                      className="h-8 px-2.5 rounded-md bg-zinc-800 text-zinc-300 text-xs font-bold border border-zinc-700 hover:border-amber-400/40 inline-flex items-center gap-1.5 transition">
                      <PaperPlaneTilt size={13} weight="bold" /> Ricevuta
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="py-10 text-center text-sm text-zinc-500">Nessun pagamento</div>}
      </div>
    </div>
  );
}
